<ng-template #modalContent let-modal>
  <div id="viewCard" class="card p-2">
    <div class="title-box text-center">
      <h6 class="m-0">
        {{ "SaleFactor" | translate }}
      </h6>
    </div>
    <div class="card-body factor-box pb-0 my-2">
      <div
        id="print-factor"
        class="width-print-factor col-12 factor-body reset-styles"
      >
        <div class="print-body row" *ngIf="recept">
          <div class="col-12 border-bottom hidden-in-show">
            <div class="row">
              <div
                class="col-6 d-flex justify-content-start align-items-center table-font"
              >
                <span>{{ recept.drugStoreName }}</span>
              </div>
              <div
                class="col-6 d-flex justify-content-end align-items-center table-font"
              >
                <p class="m-0 px-0 table-font">
                  {{ recept.drugStoreNumber | dataType : "telephone" }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "factorNumber" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.factorNumber }}
              </p>
            </div>
          </div>
          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "FactorSerial" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.barcode }}
              </p>
            </div>
          </div>
          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "factorDate" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.factorDate | persianDateTime }}
              </p>
            </div>
          </div>

          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font">
                {{ "PrescriptionDate" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.prescriptionDate | persianDate }}
              </p>
            </div>
          </div>

          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font">
                {{ "melliCode" | translate }}:
              </span>
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.patientNationalCode }}
              </p>
            </div>
          </div>

          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "PatientFullName" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.patientFullName }}
              </p>
            </div>
          </div>

          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "DoctorName" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.doctorFullName }}
              </p>
            </div>
          </div>

          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "DoctorCode" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.doctorId }}
              </p>
            </div>
          </div>

          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "insuranceName" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.insuranceName }}
              </p>
            </div>
          </div>

          <div class="col-6 font-size-print">
            <div class="d-flex justify-content-start align-items-center">
              <span class="px-0 pe-0 table-font"
                >{{ "TrackingCode" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.trackingCode }}
              </p>
            </div>
          </div>

          <div class="col-12 font-size-print text-center">
            <div class="d-flex justify-content-center">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="p-0 py-1">
                      {{ "RowSharp" | translate }}
                    </th>
                    <th class="p-0 py-1 drug-name">
                      {{ "DrugName" | translate }}
                    </th>
                    <th class="p-0 py-1">
                      {{ "count" | translate }}
                    </th>
                    <th class="p-0 py-1">
                      {{ "Noninsuredamount" | translate }}
                    </th>
                    <th class="p-0 py-1">
                      {{ "Insuranceamount" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngFor="let item of recept.drugList; let i = index"
                  >
                    <tr>
                      <td class="p-0">{{ i + 1 }}</td>
                      <td class="p-0 table-font" [innerHTML]="item.drugBranName"></td>
                      <td class="p-0">{{ item.count }}</td>
                      <td class="p-0">
                        {{ item.totalPrice | dataType : "" }}
                      </td>
                      <td class="p-0">
                        {{ item.insurancePrice | dataType : "" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="p-0" colspan="5">
                        <div class="row">
                          <div
                            class="col-12 font-size-print d-flex justify-content-evenly align-items-center"
                          >
                            <div
                              class="d-flex justify-content-start align-items-center"
                            >
                              <span class="px-0 pe-0 table-smaller-font"
                                >{{ "shareCurrencyPrice" | translate }}:</span
                              >
                              <p class="m-0 ms-2 px-0 table-smaller-font">
                                {{ item.shareCurrencyPrice | dataType : "" }}
                              </p>
                            </div>
                            <div
                              class="d-flex justify-content-start align-items-center"
                            >
                              <span class="px-0 pe-0 table-smaller-font"
                                >{{ "PatientShare" | translate }}:</span
                              >
                              <p class="m-0 ms-2 px-0 table-smaller-font">
                                {{ item.paidPrice | dataType : "" }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="item.doctorOrder !=null && item.doctorOrder!=''">
                      <td class="p-0" colspan="5">
                        <div class="row">
                          <div
                            class="col-12 font-size-print d-flex justify-content-start align-items-center"
                          >
                            <div
                              class="d-flex justify-content-start align-items-center"
                            >
                              <span class="px-0 pe-0 table-smaller-font"
                                >{{ "DoctorOrder" | translate }}:</span
                              >
                              <p class="m-0 ms-2 px-0 table-smaller-font">
                                {{ item.doctorOrder }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="item.description !=null && item.description!=''">
                      <td class="p-0" colspan="5">
                        <div class="row">
                          <div
                            class="col-12 font-size-print d-flex justify-content-start align-items-center"
                          >
                            <div
                              class="d-flex justify-content-start align-items-center"
                            >
                              <span class="px-0 pe-0 table-smaller-font"
                                >{{ "description" | translate }}:</span
                              >
                              <p class="m-0 ms-2 px-0 table-smaller-font" [innerHTML]="item.description">
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-between pb-1 hidden-in-show">
            <div class="label-box d-flex justify-content-between w-100">
              <span class="m-0 px-0 table-font"
                >{{ "TotalPrescriptionPrice" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.totalAmount | dataType : "price" }}
              </p>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-between pb-1 hidden-in-show">
            <div class="label-box d-flex justify-content-between w-100">
              <span class="m-0 px-0 table-font"
                >{{ "PatientShare" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.patientAmount | dataType : "price" }}
              </p>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-between pb-1 hidden-in-show">
            <div class="label-box d-flex justify-content-between w-100">
              <span class="m-0 px-0 table-font"
                >{{ "InsurancePrice" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.insuranceAmount | dataType : "price" }}
              </p>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-between pb-1 hidden-in-show">
            <div class="label-box d-flex justify-content-between w-100">
              <span class="m-0 px-0 table-font"
                >{{ "CurrencyPrice" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.nonInsuredPrice | dataType : "price" }}
              </p>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-between pb-1 border-bottom hidden-in-show">
            <div class="label-box d-flex justify-content-between w-100">
              <span class="m-0 px-0 table-font"
                >{{ "technicalRight" | translate }}:</span
              >
              <p class="m-0 ms-2 px-0 table-font">
                {{ recept.technicalRight | dataType : "price" }}
              </p>
            </div>
          </div>
       
          <div class="col-12">
            <div
              class="total-box d-flex justify-content-around align-items-center"
            >
              <span class="m-0 px-0">{{ "Payable" | translate }}:</span>
              <p class="m-0 ms-2 px-0">
                {{ recept.paidPrice | dataType : "price" }}
              </p>
            </div>
          </div>
          <div class="col-12 hidden-in-show">
            <app-sale-barcode [barcodeData]="recept.barcode"></app-sale-barcode>
          </div>

          <div class="col-12 d-flex justify-content-between border-top hidden-in-show">
            <div class="label-box">
              <span class="m-0 px-0">{{ "address" | translate }}:</span>
              <p class="m-0 px-0">
                {{ recept.drugStoreAddress }}
              </p>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-between border-top hidden-in-show">
            <div class="label-box">
              <span class="m-0 px-0">{{ "SystemOwner" | translate }} : </span>
              <p class="m-0 px-0">{{ "OurName" | translate }}</p>
            </div>
            <div class="label-box company-website">
              <p class="m-0 px-0">PendarPharma.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-outline-primary ms-1"
      ngbTooltip="{{ 'Print' | translate }}"
      (click)="printDiv()"
    >
      {{ "print" | translate }}
      <span class="tf-icons bx bx-printer"></span>
    </button>
  </div>
</ng-template>
